//! DO NOT IMPORT FROM THIS FILE - USE './theme-selectors.ts' INSTEAD
/**
 * Group spacing
 */
export var getGroupOneSpacing = function (theme) {
    return theme.v1.spacing.group.one;
};
export var getGroupTwoSpacing = function (theme) {
    return theme.v1.spacing.group.two;
};
export var getGroupThreeSpacing = function (theme) {
    return theme.v1.spacing.group.three;
};
export var getGroupFourSpacing = function (theme) {
    return theme.v1.spacing.group.four;
};
export var getGroupFiveSpacing = function (theme) {
    return theme.v1.spacing.group.five;
};
export var getGroupSixSpacing = function (theme) {
    return theme.v1.spacing.group.six;
};
/**
 * Distinct spacing
 */
export var getDistinctOneSpacing = function (theme) {
    return theme.v1.spacing.distinct.one;
};
export var getDistinctTwoSpacing = function (theme) {
    return theme.v1.spacing.distinct.two;
};
/**
 * Related spacing
 */
export var getRelatedOneSpacing = function (theme) {
    return theme.v1.spacing.related.one;
};
export var getRelatedTwoSpacing = function (theme) {
    return theme.v1.spacing.related.two;
};
